import React, { useState } from "react";
import styled from "styled-components";

const NameChanging = () => {
  const [copied, setCopied] = useState(false);

  const [formData, setFormData] = useState({
    oldName: "",
    newName: "",
    mobile: "",
    address: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const formattedText = `Change in Name
MY OLD NAME WAS ${formData.oldName}, WHICH I AM CHANGING TO MY NEW NAME: ${formData.newName}, HENCEFORTH.
ALL CORRESPONDENCE WILL BE DONE AS PER MY NEW NAME: ${formData.newName}
PLEASE CONSIDER THE SAME.
MOBILE NO: ${formData.mobile}
ADDRESS: ${formData.address}`;

  const handleCopyAndLog = () => {
    navigator.clipboard.writeText(formattedText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    // alert("All Text Copied!");

    const capitalizedData = {
      OLD_NAME: formData.oldName,
      NEW_NAME: formData.newName,
      MOBILE_NUMBER: formData.mobile,
      ADDRESS: formData.address,
    };

    console.log("Submitted Data:", capitalizedData);
  };

  return (
    <Container>
      <LeftSection>
        <Label>OLD NAME</Label>
        <Input
          type="text"
          name="oldName"
          placeholder="Enter Old Name"
          value={formData.oldName}
          onChange={handleChange}
        />
        <Label>NEW NAME</Label>
        <Input
          type="text"
          name="newName"
          placeholder="Enter New Name"
          value={formData.newName}
          onChange={handleChange}
        />
        <Label>MOBILE NUMBER</Label>
        <Input
          type="tel"
          name="mobile"
          placeholder="Enter Mobile Number"
          value={formData.mobile}
          onChange={handleChange}
        />
        <Label>ADDRESS</Label>
        <Textarea
          name="address"
          placeholder="Enter Address"
          rows="4"
          value={formData.address}
          onChange={handleChange}
        />
      </LeftSection>

      <RightSection>
        <Preview>
          <p>
            <strong>Change in Name</strong>
          </p>
          <p>
            MY OLD NAME WAS <strong>{formData.oldName}</strong>, WHICH I AM
            CHANGING TO MY NEW NAME: <strong>{formData.newName}</strong>,
            HENCEFORTH.
          </p>
          <p>
            ALL CORRESPONDENCE WILL BE DONE AS PER MY NEW NAME:{" "}
            <strong>{formData.newName}</strong>
          </p>
          <p>PLEASE CONSIDER THE SAME.</p>
          <p>
            MOBILE NO: <strong>{formData.mobile}</strong>
          </p>
          <p>
            ADDRESS: <strong>{formData.address}</strong>
          </p>
        </Preview>

        <CopyButton onClick={handleCopyAndLog}>COPY TEXT</CopyButton>
        {copied && <CopiedText>✔ Copied!</CopiedText>}
      </RightSection>
    </Container>
  );
};

const CopiedText = styled.p`
  margin-top: 10px;
  font-size: 0.95rem;
  color: #4ade80;
  font-weight: 600;
  animation: fadeInOut 2s ease-in-out;

  @keyframes fadeInOut {
    0% {
      opacity: 0;
      transform: translateY(10px);
    }
    10% {
      opacity: 1;
      transform: translateY(0);
    }
    90% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(-10px);
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 40px;
  gap: 30px;
  justify-content: center;
  background-color: #171719;
`;

const LeftSection = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border: 1px solid #353535;
  padding: 20px;
`;

const RightSection = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 600px;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border: 1px solid #353535;
`;

const Label = styled.label`
  margin-top: 20px;
  margin-bottom: 8px;
  font-weight: 600;
  text-transform: uppercase;
  color: #e6e6e6;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 1rem;
  border-radius: 6px;
  text-transform: uppercase;
  border: 1px solid #353535;
  background-color: transparent;
  color: #e6e6e6;
  &:focus {
    border-color: #3f51ff;
    outline: none;
  }
`;

const Textarea = styled.textarea`
  padding: 10px;
  font-size: 1rem;
  border-radius: 6px;
  text-transform: uppercase;
  border: 1px solid #1f1f21;
  background-color: transparent;
  color: #e6e6e6;
  resize: vertical;
  &:focus {
    border-color: #3f51ff;
    outline: none;
  }
`;

const Preview = styled.div`
  font-size: 1rem;
  color: #e6e6e6;
  line-height: 1.6;

  strong {
    text-transform: uppercase;
    color: #194bfd;
  }
`;

const CopyButton = styled.button`
  margin-top: 20px;
  padding: 12px 24px;
  font-size: 1rem;
  background: linear-gradient(90deg, #194bfd 0%, #ad13fb 100%);
  color: #ffffff;
  transition: all 0.3s ease;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;

  &:hover {
    background-color: #5a189a;
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);
  }
`;

export default NameChanging;
